import React from "react";
import { Link } from "react-router-dom";

export default function ServiceTile({ service, coverImage, size = "md" }) {
  const cover = service.cover_image;

  const sizes = {
    md: "aspect-[4/5]",
    lg: "aspect-[3/4] sm:aspect-[4/5]",
  };

  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-tile-${service.slug}`}
      className="group relative block overflow-hidden rounded-lg border border-[#EAE3D2] bg-white transition hover:border-[#C8A24B]"
    >
      <div className={`relative w-full overflow-hidden ${sizes[size] || sizes.md}`}>
        {cover ? (
          <img
            src={cover}
            alt={`${service.name} photography sample`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-[#EAE3D2]" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/70 via-transparent to-transparent" />
        <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
          <p className="text-[10px] uppercase tracking-[0.28em] text-[#C8A24B] sm:text-xs">
            {(service.occasions || []).slice(0, 2).join(" · ")}
          </p>
          <h3
            data-testid={`service-tile-name-${service.slug}`}
            className="mt-2 font-display text-2xl text-[#FAF7F2] sm:text-3xl"
          >
            {service.name}
          </h3>
        </div>
        <span className="pointer-events-none absolute bottom-5 left-5 right-5 h-[2px] origin-left scale-x-0 bg-[#C8A24B] transition-transform duration-500 group-hover:scale-x-100 sm:bottom-6 sm:left-6 sm:right-6" />
      </div>
    </Link>
  );
}
